import { render, staticRenderFns } from "./OrderIntergral.vue?vue&type=template&id=3524b626&scoped=true&"
import script from "./OrderIntergral.vue?vue&type=script&lang=js&"
export * from "./OrderIntergral.vue?vue&type=script&lang=js&"
import style0 from "./OrderIntergral.vue?vue&type=style&index=0&id=3524b626&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524b626",
  null
  
)

export default component.exports